module.exports = __webpack_public_path__ + "img/comprehensiveImg1.d91df42e.png";